import { render, staticRenderFns } from "./TabsPanel.vue?vue&type=template&id=6221e256&scoped=true"
import script from "./TabsPanel.vue?vue&type=script&lang=js"
export * from "./TabsPanel.vue?vue&type=script&lang=js"
import style0 from "./TabsPanel.vue?vue&type=style&index=0&id=6221e256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221e256",
  null
  
)

export default component.exports